module.exports = __webpack_public_path__ + "img/thumbnail_SlothBear_m_normal.2abb3e63.png";